import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { SignedIn, SignedOut, SignIn, SignUp } from '@clerk/clerk-react'
import { Helmet } from 'react-helmet-async'

// Pages
import DashboardPage from './pages/DashboardPage'
import UploadPage from './pages/UploadPage'
import StatementDetailsPage from './pages/StatementDetailsPage'
import CheckoutSuccessPage from './pages/CheckoutSuccessPage'
import CheckoutCancelPage from './pages/CheckoutCancelPage'
import NotFound from './pages/NotFound'

// Public (prerendered) routes — shared source of truth with entry-server.tsx
import { publicRoutes } from './routes/publicRoutes'

// Components
import { CookieConsent } from './components/CookieConsent'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes (shared with the SSR/prerender entry) */}
        {publicRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}

        {/* Auth Routes */}
        <Route path="/sign-in" element={
          <>
            <SignedOut>
              <Helmet>
                <title>Sign in · BankStatementReader</title>
                <meta name="robots" content="noindex, follow" />
                <link rel="canonical" href="https://bankstatementreader.com/sign-in" />
              </Helmet>
              <main className="min-h-screen flex items-center justify-center bg-gray-50">
                <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
              </main>
            </SignedOut>
            <SignedIn>
              <Navigate to="/dashboard" replace />
            </SignedIn>
          </>
        } />
        <Route path="/sign-up" element={
          <>
            <SignedOut>
              <Helmet>
                <title>Sign up · BankStatementReader</title>
                <meta name="robots" content="noindex, follow" />
                <link rel="canonical" href="https://bankstatementreader.com/sign-up" />
              </Helmet>
              <main className="min-h-screen flex items-center justify-center bg-gray-50">
                <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
              </main>
            </SignedOut>
            <SignedIn>
              <Navigate to="/dashboard" replace />
            </SignedIn>
          </>
        } />

        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <SignedIn>
            <DashboardPage />
          </SignedIn>
        } />
        <Route path="/upload" element={
          <SignedIn>
            <UploadPage />
          </SignedIn>
        } />
        <Route path="/statements/:id" element={
          <SignedIn>
            <StatementDetailsPage />
          </SignedIn>
        } />
        <Route path="/checkout/success" element={
          <SignedIn>
            <CheckoutSuccessPage />
          </SignedIn>
        } />
        <Route path="/checkout/cancel" element={
          <SignedIn>
            <CheckoutCancelPage />
          </SignedIn>
        } />

        {/* Catch all → real 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Cookie Consent Banner (shows globally) */}
      <CookieConsent />
    </BrowserRouter>
  )
}

export default App
